import { createSlice } from "@reduxjs/toolkit";
import {
  SET_ALERT,
  REMOVE_ALERT,
} from "../constants/action-types";

const alertSlice = createSlice({
  name: "alerts",
  initialState: [],
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SET_ALERT, (_state, { payload }) => {
        // Return a new array (Immer handles this)
        return [..._state, payload];
      })
      .addCase(REMOVE_ALERT, (state, { payload }) => {
        return state.filter((alert) => alert.id !== payload);
      });
  },
});

export const alertReducer = alertSlice.reducer;
